import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import SubscriberV2Resources from "@ane/exp-data/lib/resources/SubscriberV2Resources";
import { SUBSCRIPTION_TYPES } from "@ane/exp-data/lib/models";
const prefix = "SET_SUBSCRIBERS_V2";
const args = {
  actionPrefix: prefix,
  reduxKeyNested: () => ["value"],
  loadResource: (payload) => {
    let filteredSubscribers = payload.notificationSubscription.subscribers.filter(
      (f) => f.subscriptionType !== SUBSCRIPTION_TYPES.Admin
    );
    payload.notificationSubscription.subscribers = filteredSubscribers;
    return SubscriberV2Resources.setSubscribers(payload);
  },
  onCompleteSuccess: (result, inputPayload) => {
    return result;
  }
};
const SetSubscribersEpicReducerV2 = loadResourcesUtils(args);
const SetSubscribersV2_epics = combineEpics(SetSubscribersEpicReducerV2.epic);
export {
  SetSubscribersEpicReducerV2,
  SetSubscribersV2_epics as default
};
//# sourceMappingURL=SetSubscribersV2.epics.js.map
